export default __webpack_public_path__ + "static/media/finEdge.5962f5b0.png";